import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StockColumnRuleGateway } from "../gateway/StockColumnRuleGateway";
import { HttpClient } from "@angular/common/http";
import { CreateStockColumnRuleRequest, StockColumnRule } from "src/app/domain/models/StockColumnRule";
import { Routes } from "src/app/infrastructure/routes";

@Injectable({providedIn: 'root'})
export class StockColumnRuleService extends StockColumnRuleGateway {

  constructor(private _http: HttpClient)
  {
    super();
  }

  create(request: CreateStockColumnRuleRequest): Observable<StockColumnRule[]>
  {
    return this._http.post<StockColumnRule[]>(Routes.stockColumRuleApi + '/Create', request)
  }

  getRulesByStockId(stockId: number): Observable<StockColumnRule[]> {
    return this._http.get<StockColumnRule[]>(Routes.stockColumRuleApi + '/GetByStockId', {params: {stockId}});
  }

  delete(ruleId: number): Observable<any> {
    return this._http.delete<any>(Routes.stockColumRuleApi + '/Delete', {params: {ruleId}});
  }


}
